import {Injectable} from '@angular/core'

@Injectable()

export class ProveedoresService {


  tabla = 'rest_proveedores';
  data = [];

  constructor() {

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || [];

  }


  get() {

    return this.data;

  }


  getById(id = null) {

    let aux = null;

    for (let item of this.data) {

      if (item.id == id) {
        aux = item;
        break;
      }
    }

    return aux;
  }


  set(data) {

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }


  delete() {

    this.data = null;
    localStorage.removeItem(this.tabla);

    return this.data;
  }

}



// WEBPACK FOOTER //
// ./src/services/ProveedoresService.ts